import { IKogIcon } from "@/main/@types/interfaceIcons";

export function InvoicedIcon({ height = "50px", width = "50px", color = "currentColor" }: IKogIcon) {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 371.000000 460.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g transform="translate(0.000000,460.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
				<path
					d="M290 2285 l0 -2095 1575 0 1575 0 0 1443 0 1442 -653 653 -652 652
          -923 0 -922 0 0 -2095z m1710 1310 l0 -655 655 0 655 0 0 -1315 0 -1315 -1445
          0 -1445 0 0 1970 0 1970 790 0 790 0 0 -655z m695 35 l560 -560 -563 0 -562 0
          0 560 c0 308 1 560 3 560 1 0 254 -252 562 -560z"
				/>
				<path d="M820 3795 l0 -65 455 0 455 0 0 65 0 65 -455 0 -455 0 0 -65z" />
				<path d="M820 3265 l0 -65 455 0 455 0 0 65 0 65 -455 0 -455 0 0 -65z" />
				<path
					d="M1800 2305 l0 -84 -37 -6 c-179 -30 -279 -95 -334 -220 -25 -56 -23
          -149 4 -201 48 -93 171 -155 457 -230 124 -32 212 -71 265 -117 35 -31 38 -36
          36 -87 -1 -74 -33 -119 -108 -157 -56 -27 -63 -28 -198 -27 -121 1 -152 5
          -230 28 -49 15 -112 34 -139 42 -28 7 -57 16 -67 19 -13 5 -21 -7 -38 -56 -11
          -35 -20 -63 -18 -64 2 -2 182 -50 282 -76 39 -10 82 -19 98 -19 l27 0 0 -90 0
          -90 65 0 65 0 0 84 0 83 78 12 c105 17 184 54 232 109 76 85 102 220 60 307
          -50 103 -154 164 -400 231 -264 72 -337 108 -360 179 -17 52 14 115 77 155 91
          58 193 70 368 45 169 -26 156 -28 171 30 8 28 14 55 14 61 0 5 -53 19 -117 30
          l-118 19 -3 88 -3 87 -64 0 -65 0 0 -85z"
				/>
			</g>
		</svg>
	);
}
